import React, { useState } from "react";
import { some } from "lodash-es";
import "./CoverMeDropzone.scss";
import Dropzone from "react-dropzone";

export const CoverMeDropzone = ({
    onFileSelect,
    isValid,
    errorMessage,
    maxSize = 1024 * 1024 * 20,
    allowedFileExtensions = [],
}) => {
    const [uploadedFileName, setUploadedFileName] = useState(null);
    const [internalError, setInternalError] = useState(null);
    const [isDraggedOver, setIsDraggedOver] = useState(false);

    function onDragEnter() {
        setIsDraggedOver(true);
    }

    function onDragLeave() {
        setIsDraggedOver(false);
    }

    function getFileSize(size) {
        if (size > 1024 * 1024) {
            return `${(size / (1024 * 1024)).toFixed(2)} MB`;
        } else if (size > 1024) {
            return `${(size / 1024).toFixed(2)} KB`;
        }
    }

    function onDropRejected(files) {
        if (some(files, x => x.size > maxSize)) {
            setInternalError(`File must not be bigger than ${getFileSize(maxSize)}`);
        }
    }

    function onDrop(acceptedFiles) {
        setIsDraggedOver(false);
        if (allowedFileExtensions?.length > 0) {
            for (const file of acceptedFiles) {
                const extension = file.name.substring(file.name.lastIndexOf("."));
                if (!some(allowedFileExtensions, x => x === extension)) {
                    setInternalError("This file type is not allowed to be uploaded");
                    return;
                }
            }
        }
        if (acceptedFiles.length === 0) {
            return;
        } else {
            setInternalError(null);
        }
        if (acceptedFiles.length === 1) {
            const fileSize = getFileSize(acceptedFiles[0].size);
            setUploadedFileName(`${acceptedFiles[0].name} (${fileSize})`);
        } else {
            setUploadedFileName("Multiple files uploaded");
        }

        onFileSelect(acceptedFiles);
    }

    return (
        <Dropzone
            onDrop={onDrop}
            multiple={false}
            maxSize={maxSize}
            onDropRejected={onDropRejected}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
        >
            {({ getRootProps, getInputProps }) => (
                <section className="drop-zone">
                    <div className={`drop-zone-input ${isDraggedOver ? "dragged-over" : ""}`} {...getRootProps()}>
                        {internalError != null && (
                            <span className="validation-error paragraph-small">{internalError}</span>
                        )}
                        {!isValid && internalError == null && (
                            <span className="validation-error paragraph-small">{errorMessage}</span>
                        )}
                        <input {...getInputProps()} accept={allowedFileExtensions?.join(",")} />
                        {uploadedFileName == null && <p>Click here or drag a file to begin the upload</p>}
                        {uploadedFileName != null && <p>{uploadedFileName}</p>}
                    </div>
                </section>
            )}
        </Dropzone>
    );
};
